export class Erb {
  cellid: number;
  lac: number;
  mnc: number;
  mcc: number;
  lat?: string;
  lng?: string;
  rssi?: number;
  base_erb?: string;
  lat_lng?: string;
  azimuth?: number;
  ta?: number;

  constructor() {
    (this.cellid = -1),
      (this.lac = -1),
      (this.mnc = -1),
      (this.mcc = -1),
      (this.lat = ''),
      (this.lng = '');
      (this.ta = 100)
  }
}
